import React from "react";
import CustomTable from "../../helpers/customtable";
import "../../../css/ClientsTable.css";

export default function ClientsList({ clients, t, loading = false, onRowClick, onModify, onDelete }) {
  const column = (key, header, width, align = "left") => ({
    key, header: t(header), shortHeader: t(`clientsHeaderShort_${header}`),
    width, align, default: t("notAvailable"),
  });
  const config = {
    rowKey: "clientId", emptyText: t("noClients"), pageSize: 10,
    showPageSizeSelector: true, pageSizeOptions: [10, 25, 50, 100], showTotalCount: true,
    labels: { filter: t("filter"), search: t("search"), actions: t("actions") },
    columns: [
      column("clientId", "id", "10%"),
      { ...column("name", "name", "30%"), fixed: true },
      column("clientSold", "clientSold", "15%", "right"),
      column("address", "address", "40%"),
      { key: "actions", width: "5%", text: "...", appearOnHover: true, actionlist: [
        { key: "edit", label: t("modify"), icon: "bi-pencil", onClick: (client) => onModify(client.clientId) },
        { key: "delete", label: t("delete"), icon: "bi-trash", onClick: (client) => onDelete(client.clientId) },
      ] },
    ],
    onRowClick: (client) => onRowClick(client.clientId),
  };
  return <div className="clients-table"><CustomTable data={clients} config={config} loading={loading} /></div>;
}
